/**
 * NumInput — small numeric input with optional unit suffix, used across the
 * rate-card editor and pricing preview.
 */
import React from "react";

export default function NumInput({ value, onChange, suffix, min = 0, max = 100000, step = 1, className = "", testid }) {
  return (
    <div className={`inline-flex items-center gap-1 ${className}`}>
      <input
        type="number"
        value={value ?? ""}
        min={min}
        max={max}
        step={step}
        onChange={(e) => onChange(e.target.value === "" ? "" : Number(e.target.value))}
        className="w-20 border border-zinc-300 px-2 py-1 text-[12.5px] text-right tabular-nums focus:outline-none focus:border-[#7737F6]"
        data-testid={testid}
      />
      {suffix && <span className="text-[11px] text-zinc-500">{suffix}</span>}
    </div>
  );
}
